import React from 'react'
import { FormattedMessage } from 'react-intl'
import SidebarWidget from './SidebarWidget'
import styles from './_sidebarWidget.css'
import { Button } from 'components/util'
import goMobile from 'images/goMobile.png'

export default function GoMobileWidget () {
  return (
    <SidebarWidget>
      <h3>
        <FormattedMessage
          id='workout.create.aside.go_mobile_title'
          defaultMessage='Go Mobile'
        />
      </h3>
      <a href='/app/'>
        <img src={goMobile} className={styles.sidebarImage} />
      </a>
      <p className={styles.sidebarContent}>
        <FormattedMessage
          id='workout.create.aside.go_mobile_content'
          defaultMessage='Download the Free App Use your smartphone GPS to track distance, speed and calories.'
        />
      </p>
      <div className={styles.sidebarCTA}>
        <a href='/app/'>
          <Button type='secondary' size='small'>
            <FormattedMessage
              id='workout.create.aside.go_mobile_cta'
              defaultMessage='Go Mobile'
            />
          </Button>
        </a>
      </div>
    </SidebarWidget>
  )
}



// WEBPACK FOOTER //
// ./src/components/sidebar/GoMobile.jsx